import React from 'react';
import { Box } from "@chakra-ui/react";

const AttractiveLoadingSpinner = ({ size = "200px", primaryColor = "#3182CE", secondaryColor = "#63B3ED" }) => (
  <Box
    width={size}
    height={size}
    position="relative"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width="100%"
      height="100%"
    >
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor={primaryColor} />
          <stop offset="100%" stopColor={secondaryColor} />
        </linearGradient>
      </defs>
      <circle
        cx="50"
        cy="50"
        r="40"
        stroke="url(#gradient)"
        strokeWidth="8"
        fill="none"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          dur="2s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-dasharray"
          values="0 251.2; 188.4 62.8; 251.2 0"
          dur="2.4s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-dashoffset"
          values="0; -62.8; -251.2"
          dur="2.4s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  </Box>
);

export default AttractiveLoadingSpinner;